module.exports = __webpack_public_path__ + "static/media/MilestoneSubmission.f062f617.png";